import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage, socketErrorMessage } from './wsHelpers';
import { connect } from 'react-redux';
import {
	updateAttendee,
	updateAttendeeMetaData,
	deleteAttendee,
	addGroupsToAttendee,
	removeGroupsFromAttendee,
	assignBadgeToAttendee,
} from '@/redux/actions';

const WS_ATTENDEE_BY_HTTP = {
	UPDATE: 'attendee/:attendeeID/PATCH',
	UPDATE_METADATA: 'attendee/metadata/:attendeeID/PATCH',
	DELETE: 'attendee/:attendeeID/DELETE',
	ADD_GROUPS: 'attendee/:attendeeID/addGroups/PATCH',
	REMOVE_GROUPS: 'attendee/:attendeeID/removeGroups/PATCH',
	UPDATED_BADGES: 'attendee/:attendeeID/badges/:badgeID',
};

const AttendeeSubscriptions = props => {
	const {
		socket,
		children,
		attendeeID,
		updateAttendee,
		updateAttendeeMetaData,
		addGroups,
		removeGroups,
		updateBadge,
		route,
	} = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToAttendee = () => {
		socket.emit('attendee/:attendeeID/SUBSCRIBE', { attendeeID });
	};

	const unsubscribeToAttendee = () => {
		socket.emit('attendee/:attendeeID/UNSUBSCRIBE', { attendeeID });
	};

	const listenForUpdatedAttendee = () => {
		socket.on(WS_ATTENDEE_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) {
				if (socketErrorMessage(error).includes('Duplicate entry')) {
					displayMessage(
						'Account could not be updated: That email address is already in use.',
						error
					);
				} else {
					displayMessage('Account could not be updated', error);
				}
			} else {
				updateAttendee({ attendee: data });
				displayMessage('Account Updated');
			}
		});
	};

	const listenForUpdatedMetadata = () => {
		socket.on(WS_ATTENDEE_BY_HTTP.UPDATE_METADATA, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Account Metadata could not be updated', error);
			else {
				updateAttendeeMetaData(data);
			}
		});
	};

	const listenForDeletedAttendee = () => {
		socket.on(WS_ATTENDEE_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Account could not be deleted', error);
			else {
				deleteAttendee({ attendeeID: data.id });
				displayMessage('Account deleted');
			}
			window.history.back();
		});
	};

	const listenForAddedGroupsAttendee = () => {
		socket.on(WS_ATTENDEE_BY_HTTP.ADD_GROUPS, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Groups could not be added', error);
			else {
				addGroups({ groups: data });
				displayMessage('Groups added to attendee');
			}
		});
	};

	const listenForRemovedGroupsAttendee = () => {
		socket.on(WS_ATTENDEE_BY_HTTP.REMOVE_GROUPS, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Groups could not be removed', error);
			else {
				removeGroups({ groups: data });
				displayMessage('Groups removed from attendee');
			}
		});
	};

	const listenForUpdatedBadges = () => {
		socket.on(WS_ATTENDEE_BY_HTTP.UPDATED_BADGES, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Badge could not be updated', error);
			else {
				updateBadge(data);
				displayMessage('Badge saved');
			}
		});
	};

	const listeners = () =>
		route === '/accounts'
			? [listenForUpdatedAttendee, listenForDeletedAttendee]
			: [
					listenForUpdatedAttendee,
					listenForUpdatedMetadata,
					listenForDeletedAttendee,
					listenForAddedGroupsAttendee,
					listenForRemovedGroupsAttendee,
					listenForUpdatedBadges,
			  ];
	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToAttendee}
				unsub={unsubscribeToAttendee}
				listeners={listeners()}
				routes={Object.values(WS_ATTENDEE_BY_HTTP)}
				from="AttendeeSubscriptions"
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = state => ({
	attendeeID: state.attendee.attendeeInfo.id,
	socket: state.ws.socket,
	auth0Token: state.auth.auth0Token,
	currentEventId: state.events.currentEvent.id,
});

const mdp = dispatch => ({
	updateAttendee: attendee => dispatch(updateAttendee(attendee)),
	updateAttendeeMetaData: metadata => dispatch(updateAttendeeMetaData(metadata)),
	deleteAttendee: data => dispatch(deleteAttendee(data)),
	addGroups: groups => dispatch(addGroupsToAttendee(groups)),
	removeGroups: groups => dispatch(removeGroupsFromAttendee(groups)),
	updateBadge: badge => dispatch(assignBadgeToAttendee(badge)),
});

export default connect(msp, mdp)(AttendeeSubscriptions);
